import React from 'react';
import { Chip } from '@mui/material';
import { ValidationStatus } from '../../types/validation.types';
import { 
  Pending, 
  PlayArrow, 
  CheckCircle, 
  Error as ErrorIcon 
} from '@mui/icons-material';

interface ValidationStatusBadgeProps {
  status: ValidationStatus;
  size?: 'small' | 'medium';
}

const STATUS_CONFIG: Record<ValidationStatus, { 
  color: 'default' | 'primary' | 'success' | 'error'; 
  label: string; 
  icon: React.ReactNode 
}> = {
  PENDING: { color: 'default', label: 'Pending', icon: <Pending fontSize="small" /> },
  RUNNING: { color: 'primary', label: 'Running', icon: <PlayArrow fontSize="small" /> },
  COMPLETED: { color: 'success', label: 'Completed', icon: <CheckCircle fontSize="small" /> },
  FAILED: { color: 'error', label: 'Failed', icon: <ErrorIcon fontSize="small" /> },
};

const ValidationStatusBadge: React.FC<ValidationStatusBadgeProps> = ({ status, size = 'small' }) => {
  const config = STATUS_CONFIG[status];

  return (
    <Chip
      label={config.label}
      color={config.color}
      size={size}
      icon={config.icon as any}
      sx={{ fontWeight: 600 }}
    />
  );
};

export default ValidationStatusBadge;
